import React from 'react';
import { DentalSchedulingDashboardWithProvider } from '../../basicOrganizationApplications/components/DentalSchedulingDashboard';
import { AppNameMap, EntityNameMap } from '../../../../../shared/utils/engagementAnalyticsTransformers';
import PlatformDashboardShell from './PlatformDashboardShell';
import { PlatformOrganizationItemModel } from './PlatformOrganizationItem';
import PlatformSchedulingManagement from './PlatformSchedulingManagement';

interface PlatformSchedulingDashboardContentProps {
    organizations: PlatformOrganizationItemModel[];
    managementOrganizations: PlatformOrganizationItemModel[];
    appNameMap: AppNameMap;
    entityNameMap: EntityNameMap;
    representativeAppId?: string;
    platformAppIdsByOrganizationId: Record<string, string[]>;
    selectedAppLiveStatusMap?: Record<string, boolean>;
    hasOutboundCallApps: boolean;
    canManageQueues: boolean;
    loadErrors?: string[];
    discoveryProgress?: {
        loadedCount: number;
        totalCount: number;
        isComplete: boolean;
        hasErrors: boolean;
    };
    onReload?: () => void;
    isLoading: boolean;
}

const PlatformSchedulingDashboardContent: React.FC<PlatformSchedulingDashboardContentProps> = (props) => {
    return (
        <PlatformDashboardShell
            title="Platform Scheduling"
            variant="scheduling"
            organizations={props.organizations}
            managementOrganizations={props.managementOrganizations}
            appNameMap={props.appNameMap}
            selectedAppLiveStatusMap={props.selectedAppLiveStatusMap}
            entityNameMap={props.entityNameMap}
            representativeAppId={props.representativeAppId}
            platformAppIdsByOrganizationId={props.platformAppIdsByOrganizationId}
            isOutboundCallApp={props.hasOutboundCallApps}
            loadErrors={props.loadErrors}
            discoveryProgress={props.discoveryProgress}
            onReload={props.onReload}
            isLoading={props.isLoading}
            DashboardComponent={DentalSchedulingDashboardWithProvider}
            ManagementComponent={props.canManageQueues ? PlatformSchedulingManagement : undefined}
        />
    );
};

export default PlatformSchedulingDashboardContent;
